import Backend from 'backend';
import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {ValidationRules, ValidationController} from 'aurelia-validation';
import {RangeOverrideValueConverter} from 'util/range-override-value-converter';

@inject(Backend, Router, ValidationController)
export class CustomerPriceGroupEditScreen {
  backend;
  router;
  validationController;

  constructor(backend, router, validationController) {
    this.backend = backend;
    this.router = router;
    this.validationController = validationController;
  }

  activate(params) {
    return Promise.all([
        this.backend.CustomerPriceGroupCrud_getForEdit(params.customerPriceGroupId)
          .then(result => {
            this.editcustomerPriceGroup = result.customerPriceGroupEditDto;
          }),
      ])
      .catch(error => this.queryError = "Error: " + error.toString())
  }

  bind() {
    ValidationRules
      .ensure('name')
      .displayName('Navn')
      .required()
      .on(this.editcustomerPriceGroup);
  }

  submit() {
    return this.validationController.validate()
      .then(result => {
        if (!result.valid) {
          return;
        }
        return this.backend.CustomerPriceGroupCrud_edit(this.editcustomerPriceGroup.customerPriceGroupId, this.editcustomerPriceGroup)
          .then(() => this.router.navigateToRoute("customer-price-group-details", {customerPriceGroupId: this.editcustomerPriceGroup.customerPriceGroupId}));
      });
  }
}
